import { render, staticRenderFns } from "./blueprint-channels.vue?vue&type=template&id=23751e71&scoped=true&"
import script from "./blueprint-channels.vue?vue&type=script&lang=ts&"
export * from "./blueprint-channels.vue?vue&type=script&lang=ts&"
import style0 from "./blueprint-channels.vue?vue&type=style&index=0&id=23751e71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23751e71",
  null
  
)

export default component.exports